import React, { memo } from 'react';
import Iconfont from '@gp/components/Iconfont';
import classNames from 'classnames';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

interface TriggerControlBtnPropsType {
  className?: string;
  style?: React.CSSProperties;
  iconClassName?: string;
  iconStyle?: React.CSSProperties;
  isFold: boolean;
  foldText?: string;
  unFoldText?: string;
  onClick: () => void;
}

const DEFAULT_PROPS: TriggerControlBtnPropsType = {
  className: '',
  style: {},
  iconClassName: '',
  iconStyle: {},
  isFold: false,
  foldText: 'Show',
  unFoldText: 'Fold',
  onClick: () => {},
};

function TriggerControlBtn(props: TriggerControlBtnPropsType) {
  const {
    className,
    style,
    iconClassName,
    iconStyle,
    isFold,
    foldText,
    unFoldText,
    onClick,
  } = props;

  return (
    <label
      className={classNames({
        'dbg-common-trigger-control-btn': true,
        'arrow-top-effect': !isFold,
        [className as string]: !!className,
      })}
      style={style}
      onClick={onClick}
    >
      {isFold ? foldText : unFoldText}
      <SvgIcon
        className={classNames({
          'dbg-common-trigger-control-icon': true,
          [iconClassName as string]: !!iconClassName,
        })}
        style={iconStyle}
        type="arrow-down"
      />
    </label>
  );
}

TriggerControlBtn.defaultProps = DEFAULT_PROPS;

export default memo(TriggerControlBtn);
